export default {
  methods: {
    typingOver() {
      this.isTypingOver = true;
    },
    onTypedChar(typedChar, typedCharIndex) {
      if (typedCharIndex == 0) {
        this.countWord = 0;
        document.querySelector(".vue-typer").firstChild.innerHTML = "";
      }
      var lessNodes = document.querySelector(".vue-typer").lastChild.childNodes;
      if (typedChar == " " || lessNodes.length == 1) {
        var finalNodes = document.querySelector(".vue-typer").firstChild;
        var listNodes = finalNodes.childNodes;

        var newNode = document.createElement("span");

        var x = this.countWord;
        var countNodes = listNodes.length;
        while (x < countNodes) {
          if (listNodes[this.countWord].innerHTML != " ")
            newNode.insertAdjacentElement("beforeend", listNodes[this.countWord]);
          else this.countWord++;

          // TODO: ADD LAST CHAR
          x++;
        }
        newNode.className = "nowrap";
        finalNodes.insertAdjacentElement("beforeend", newNode);

        this.countWord++;
      }
    },

    colorNumbers() {
      let RegExNumbers = /^[0-9]+$/;
      let letters = document.querySelectorAll(".typed");
      letters.forEach(letter => {
        if (letter.textContent.match(RegExNumbers)) {
          letter.classList.add("text-blue");
        }
      });
    },
    colorLastNumber() {
      let RegExNumbers = /^[0-9]+$/;
      let letters = document.querySelectorAll(".typed");
      let numbers = [...letters].filter(letter => letter.textContent.match(RegExNumbers));
      numbers.forEach(number => {
        if (numbers[numbers.length - 1] === number) {
          number.classList.add("text-blue");
        }
      });
    },
  },
};
